import React from "react";
import { useLocalization } from "../../../hooks/useLocalization";

export const ContactStep = ({ form, update }) => {
  const { t } = useLocalization();
  return (
    <div data-testid="wizard-step-contact" className="space-y-4">
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.legalName")}</label>
        <input data-testid="apply-legal-name-input" required value={form.legal_name} onChange={(e) => update({ legal_name: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
      </div>
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.email")}</label>
        <input data-testid="apply-email-input" required type="email" value={form.email} onChange={(e) => update({ email: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
      </div>
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.phone")}</label>
        <input data-testid="apply-phone-input" required value={form.phone} onChange={(e) => update({ phone: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
      </div>
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block">{t("careers.notesLabel")}</label>
        <textarea data-testid="apply-notes-input" rows={3} value={form.notes} onChange={(e) => update({ notes: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
      </div>
    </div>
  );
};

